import axios from "../helpers/bearerAxios";
import { logger } from "./loggingService";


const validationTest = async (): Promise<GetUserCapabilityResponse> => {
    try {
        const response = await axios.get(import.meta.env.VITE_GET_USER_CAPABILITY!);
        return response.data;
    } catch (e: any) {
        if (e.response) {
            console.error("Response error:", e.response.status, e.response.data);
        } else if (e.request) {
            console.error("No response received:", e.request);
        } else {
            console.error("Request setup error:", e.message);
        }
        logger.error(e);
        throw e;
    }
}

const userCapabilityService = {
    validationTest
}

export default userCapabilityService;
